/* unplugin-vue-components disabled */import script from "./menuLayout.vue?vue&type=script&setup=true&lang=ts"
export * from "./menuLayout.vue?vue&type=script&setup=true&lang=ts"

import "./menuLayout.vue?vue&type=style&index=0&id=09568e9a&lang=scss"

const __exports__ = script;

export default __exports__